// import { queryClient } from "@shared/api/queries/queryClient";
// import { Button } from "@shared/ui/button";
// import { Card } from "@shared/ui/card";
// import { Modal } from "@shared/ui/modal";
// import { PageHeader } from "@shared/ui/pageHeader";
// import { DivideCircle, Plus } from "lucide-react";
// import React, { useState } from "react";
// import {
//   useProgressData,
//   useToggleUtilityStatus,
//   useUpdateUtility,
//   useUtilities,
// } from "../../hooks";
// import { Utility } from "../../types";
// import UtilityAddForm from "../utility-add/utility-add";
// import SetupProgressCard from "./components/SetupStepCard";
// import UtilityCard from "./components/UtilityCard";
// import { usePermissions } from "@features/core/hooks/usePermissions";

// const UtilitySetupLanding: React.FC = () => {
//   const {
//     data: utilitiesData = [],
//     isLoading,
//     error,
//     refetch,
//   } = useUtilities();

//   const utilities = Array.isArray(utilitiesData) ? utilitiesData : [];
//   const { data: progrssData } = useProgressData();
//   const progress = progrssData?.overallUtilityProgress ?? 0;
//   const updateUtilityMutation = useUpdateUtility();
//   const { mutate: toggleUtilityStatus } = useToggleUtilityStatus();

//   // Add permission check
//   const { canCreate } = usePermissions();

//   const [isAddUtilityOpen, setIsAddUtilityOpen] = useState(false);
//   const [editUtility, setEditUtility] = useState<Utility | null>(null);

//   const handleAddUtility = () => setIsAddUtilityOpen(true);

//   const handleEditUtility = (id: number) => {
//     const utility = utilities.find((util) => util.id === id);
//     if (utility) setEditUtility(utility);
//   };

//   const handleToggleStatus = (id: number, isActive: boolean) => {
//     toggleUtilityStatus(
//       { id, isActive: isActive },
//       {
//         onSuccess: async () => {
//           await queryClient.invalidateQueries({
//             queryKey: ["onboarding", "utilitySetup"],
//             exact: false,
//           });
//         },
//       }
//     );
//   };

//   if (error) {
//     return (
//       <div className="flex flex-col items-center justify-center h-64 space-y-3">
//         <p className="text-destructive">Failed to load utilities</p>
//         <Button onClick={() => refetch()}>Try Again</Button>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="flex flex-col gap-5">
//         <div>
//           <p className="page-title ">Setup Dashboard</p>
//           <p className="page-subtitle ">Configure your utility management system and track setup progress</p>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
//           <SetupProgressCard progress={progress} className="p-6 w-full" />
//           <Card className="p-6">
//             <h3 className="text-lg font-bold mb-3">
//               Welcome to your Setup Dashboard!
//             </h3>
//             <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1">
//               <li>
//                 <strong>Add, edit, activate, or deactivate</strong> utilities anytime.
//               </li>
//               <li>Details can be edited at any progress percentage.</li>
//               <li>Toggle activation instantly—no minimum setup required.</li>
//               <li>
//                 Use <strong>Continue Setup</strong> or <strong>Edit</strong> on any card.
//               </li>
//               <li>
//                 Click <strong>+</strong> to add another utility.
//               </li>
//             </ul>
//           </Card>
//         </div>

//         <div className="mb-2">
//           <div className="flex justify-between items-center mb-2">
//             <h2 className="text-lg md:text-xl font-medium">
//               Configured Utilities
//             </h2>

//             {/* Only show Add button if user has create permission */}
//             {canCreate('OX','Utility Setup') && (
//               <Button size="sm" className="gap-1" onClick={handleAddUtility}>
//                 <Plus className="h-4 w-4" />
//                 Add Utility
//               </Button>
//             )}
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
//             {utilities.map((utility) => (
//               <div
//                 key={utility.id}
//                 className="transition-all duration-300 hover:shadow-xl hover:-translate-y-1 rounded-xl"
//               >
//                 <UtilityCard
//                   id={utility.id.toString()}
//                   name={utility.name}
//                   description={utility.description}
//                   isActive={utility.isActive}
//                   setupProgress={utility.setupPercentage}
//                   onActivateToggle={(id, active) =>
//                     handleToggleStatus(Number(id), active)
//                   }
//                   onEditUtility={(id) => handleEditUtility(Number(id))}
//                   utility={utility}
//                   // No need to pass permission props - handled inside UtilityCard
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Add Utility Modal - only render if user has create permission */}
//       {canCreate('OX') && (
//         <Modal
//           isOpen={isAddUtilityOpen}
//           onClose={() => setIsAddUtilityOpen(false)}
//           className="max-w-2xl p-0 overflow-hidden"
//         >
//           <UtilityAddForm
//             onCancel={() => setIsAddUtilityOpen(false)}
//             mode="add"
//           />
//         </Modal>
//       )}

//       <Modal
//         isOpen={!!editUtility}
//         onClose={() => setEditUtility(null)}
//         className="max-w-2xl p-0 overflow-hidden"
//       >
//         {editUtility && (
//           <UtilityAddForm
//             mode="edit"
//             utility={editUtility}
//             onCancel={() => setEditUtility(null)}
//           />
//         )}
//       </Modal>
//     </div>
//   );
// };

// export default UtilitySetupLanding;

import { queryClient } from "@shared/api/queries/queryClient";
import { Button } from "@shared/ui/button";
import { Card } from "@shared/ui/card";
import { Modal } from "@shared/ui/modal";
import { PageHeader } from "@shared/ui/pageHeader";
import { DivideCircle, Plus } from "lucide-react";
import React, { useState } from "react";
import {
  useProgressData,
  useToggleUtilityStatus,
  useUpdateUtility,
  useUtilities,
} from "../../hooks";
import { Utility } from "../../types";
import UtilityAddForm from "../utility-add/utility-add";
import SetupProgressCard from "./components/SetupStepCard";
import UtilityCard from "./components/UtilityCard";
import { useGetDashboardData } from "@shared/api/hooks";

const UtilitySetupLanding: React.FC = () => {
  const {
    data: utilitiesData = [],
    isLoading,
    error,
    refetch,
  } = useUtilities();

  const utilities = Array.isArray(utilitiesData) ? utilitiesData : [];
  console.log("Utilities Data: ", utilities);
  const {data: utilityDashboard} = useGetDashboardData('utility_admin_dashboard');
  const { data: progrssData } = useProgressData();
  const progress = progrssData?.overallUtilityProgress ?? 0;

  const updateUtilityMutation = useUpdateUtility();
  const { mutate: toggleUtilityStatus } = useToggleUtilityStatus();

  const [isAddUtilityOpen, setIsAddUtilityOpen] = useState(false);
  const [editUtility, setEditUtility] = useState<Utility | null>(null);

  // Handle utility actions
  const handleAddUtility = () => setIsAddUtilityOpen(true);
  const handleEditUtility = (id: number) => {
    const utility = utilities.find((util) => util.id === id);
    if (utility) setEditUtility(utility);
  };

  const handleToggleStatus = (id: number, isActive: boolean) => {
    toggleUtilityStatus(
      { id, isActive: isActive },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            queryKey: ["onboarding", "utilitySetup"],
            exact: false,
          });
        },
      }
    );
  };

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-64 space-y-3">
        <p className="text-destructive">Failed to load utilities</p>
        <Button onClick={() => refetch()}>Try Again</Button>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-col gap-5">
        <div>
          <p className="page-title ">Setup Dashboard</p>
          <p className="page-subtitle ">
            Configure your utility management system and track setup progress
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
          <SetupProgressCard progress={progress} className="p-6 w-full" />

          <Card className="p-6">
            <h3 className="text-lg font-bold mb-3">
              Welcome to your Setup Dashboard!
            </h3>
            <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1">
              <li>
                <strong>Add, edit, activate, or deactivate</strong> utilities
                anytime.
              </li>
              <li>Details can be edited at any progress percentage.</li>
              <li>Toggle activation instantly—no minimum setup required.</li>
              <li>
                Use <strong>Continue Setup</strong> or <strong>Edit</strong> on
                any card.
              </li>
              <li>
                Click <strong>+</strong> to add another utility.
              </li>
            </ul>
          </Card>
        </div>

        <div className="mb-2">
          <div className="flex justify-between items-center mb-2">
            <h2 className="text-lg md:text-xl font-medium">
              Configured Utilities
            </h2>
            <Button size="sm" className="gap-1" onClick={handleAddUtility}>
              <Plus className="h-4 w-4" />
              Add Utility
            </Button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {utilities.map((utility) => (
              <div
                key={utility.id}
                className="transition-all duration-300 hover:shadow-xl hover:-translate-y-1 rounded-xl"
              >
                <UtilityCard
                  id={utility.id.toString()}
                  name={utility.name}
                  description={utility.description}
                  isActive={utility.isActive}
                  setupProgress={utility.setupPercentage}
                  onActivateToggle={(id, active) =>
                    handleToggleStatus(Number(id), active)
                  }
                  onEditUtility={(id) => handleEditUtility(Number(id))}
                  utility={utility}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <Modal
        isOpen={isAddUtilityOpen}
        onClose={() => setIsAddUtilityOpen(false)}
        className="max-w-2xl p-0 overflow-hidden"
      >
        <UtilityAddForm
          onCancel={() => setIsAddUtilityOpen(false)}
          mode="add"
        />
      </Modal>

      <Modal
        isOpen={!!editUtility}
        onClose={() => setEditUtility(null)}
        className="max-w-2xl p-0 overflow-hidden"
      >
        {editUtility && (
          <UtilityAddForm
            mode="edit"
            utility={editUtility}
            onCancel={() => setEditUtility(null)}
          />
        )}
      </Modal>
    </div>
  );
};

export default UtilitySetupLanding;
